import { Injectable } from '@angular/core';

import { RestService } from './rest.service';

import { environment } from '../../../environments/environment';

@Injectable()
export class MemberService {
  constructor(private readonly rest: RestService) {}

  getMembers(businessId: number): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/member?businessId=${businessId}`);
  }

  createMember(payload: any): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/core/member`, payload);
  }

  updateMember(memberId: number, payload: any): Promise<any> {
    return this.rest.put(`${environment.apiUrl}/api/core/member/${memberId}`, payload);
  }

  deleteMember(memberId: number): Promise<any> {
    return this.rest.delete(`${environment.apiUrl}/api/core/member/${memberId}`);
  }
}
